import { useCallback, useRef } from 'react'

interface SelectAllOnFocusHandlers {
  onFocus: (event: React.FocusEvent<HTMLInputElement>) => void
  onMouseUp: (event: React.MouseEvent<HTMLInputElement>) => void
}

/* Chrome-address-bar editing: the click that focuses the field selects all
   text (type to replace), later clicks place the caret. The mouse-up guard
   keeps the browser's default caret drop from collapsing the selection the
   focus handler just made. */
export const useSelectAllOnFocus = (): SelectAllOnFocusHandlers => {
  const selectionPendingRef = useRef(false)
  const onFocus = useCallback((event: React.FocusEvent<HTMLInputElement>) => {
    event.currentTarget.select()
    selectionPendingRef.current = true
  }, [])
  const onMouseUp = useCallback((event: React.MouseEvent<HTMLInputElement>) => {
    if (!selectionPendingRef.current) return
    selectionPendingRef.current = false
    event.preventDefault()
  }, [])
  return { onFocus, onMouseUp }
}
